import React from "react";
import { DocumentFormatLabels } from "../../constants";
import { formatDate } from "../../helperFunctions";
import type { PatientDocumentDto } from "../../types/patientDocument";

interface SurgeryRelatedDocumentsProps {
  documents: PatientDocumentDto[];
  onDocumentClick: (document: PatientDocumentDto) => void;
}

export const SurgeryRelatedDocuments: React.FC<
  SurgeryRelatedDocumentsProps
> = ({ documents, onDocumentClick }) => {
  if (!documents.length) {
    return (
      <div className="rounded-md border border-dashed border-slate-200 bg-white px-4 py-3 text-sm text-slate-500">
        Δεν υπάρχουν συνδεδεμένα αποτελέσματα εξετάσεων για αυτό το χειρουργείο.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
        Σχετιζόμενα Αποτελέσματα Εξετάσεων ({documents.length})
      </div>
      <div className="overflow-hidden rounded-md border border-slate-200 bg-white">
        <table className="w-full text-left text-sm text-slate-700">
          <thead className="bg-slate-100 text-xs uppercase text-slate-600">
            <tr>
              <th className="px-3 py-2 font-semibold">Τίτλος</th>
              <th className="px-3 py-2 font-semibold">Τύπος</th>
              <th className="px-3 py-2 font-semibold">Ημ/νία</th>
              <th className="px-3 py-2 font-semibold">Format</th>
              <th className="px-3 py-2 font-semibold text-right">Προβολή</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {documents.map((doc) => (
              <tr
                key={doc.documentId}
                onClick={(e) => {
                  e.stopPropagation();
                  onDocumentClick(doc);
                }}
                className="cursor-pointer transition-colors hover:bg-lightprimary"
              >
                <td className="px-3 py-2">{doc.fileName || "-"}</td>
                <td className="px-3 py-2">{doc.documentDescr || "-"}</td>
                <td className="px-3 py-2">
                  {doc.examinationDate ? formatDate(doc.examinationDate) : "-"}
                </td>
                <td className="px-3 py-2">
                  {DocumentFormatLabels[doc.format] ?? doc.format ?? "-"}
                </td>
                <td className="px-3 py-2 text-right">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDocumentClick(doc);
                    }}
                    className="text-xs font-medium text-primary hover:underline"
                  >
                    Άνοιγμα
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/** Documents whose patientSurgery link list includes the given surgeryId. */
export function getDocumentsForSurgery(
  documents: PatientDocumentDto[],
  surgeryId: number,
): PatientDocumentDto[] {
  return documents.filter((doc) =>
    (doc.patientSurgery ?? []).some((s) => s.surgeryId === surgeryId),
  );
}
